import {cancel, logout} from '@/utils/logout'

export default {
  methods: {
    cancel() {
      this.$confirm('您确定注销吗?', '提示', {
        type: 'warning'
      }).then(() => {
        cancel().then(() => {
          this.$router.push(this.$route.name === 'platform' ? { name: 'users' } : { name: 'platform', query: { cancel: true } });
        });
      }).catch(() => {});
    },
    logout() {
      this.$confirm('您确定退出吗?', '提示', {
        confirmButtonText: '坚持要走',
        cancelButtonText: '不走了',
        type: 'warning'
      }).then(() => {
        logout();
      }).catch(() => {});
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/logout-mixin.js